<template>
  <div>
    <v-text-field v-model="text" placeholder="Поиск (Ф.И.О., Телефон, Сообщение)..." hide-details flat solo clearable>
      <template v-slot:prepend-inner>
        <v-icon>mdi-magnify</v-icon>
      </template>
    </v-text-field>
  </div>

</template>

<script>
import Stater from "@/plugins/stater";

export default {
  mounted() {
    let s = this.$tools.storageGet('contactCenter_chat_search');
    if(!this.$tools.isEmpty(s)){
      this.text = s;
      this.$tools.storageSet('contactCenter_chat_search')
    }
  },
  data: () => ({
    text: null,
    state: new Stater()
  }),
  watch:{
    text() {
      this.state.stateLoading();
      this.$tools.debounce(()=> {
        this.$emit('search', this.text)
      }, 1000, 'chatSearch')
    }
  }
}
</script>